import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    modoIcon: { display: 'flex', alignItems: 'center'},
    outlet: { height: "100%"}
  };
});
